import { Services } from '@kizi/comparator-core';
import { AvailabilityIcon } from './AvailabilityIcon';
import { DisplayGroup } from './groupInterfaces';

const getRateDisplay = (rate: number): string =>
  `€ ${rate.toFixed(2)} per minuut`;

export const getCallGroup = (
  callInfo: Services['callInfo'],
): DisplayGroup[] => {
  if (!callInfo) {
    return [];
  }

  const {
    bundles,
    numberPorting,
    rate: { rateWithinRegion, rateOutsideRegion, mobile },
    callerIdVisibility,
    voicemail,
  } = callInfo;

  return [
    {
      label: 'Onbeperkt bellen',
      tooltip:
        'Met onbeperkt bellen betaal je niet meer per minuut, maar betaal je een vast bedrag per maand voor al je telefoongesprekken.',
      value: AvailabilityIcon(bundles),
    },
    {
      label: 'Nummerbehoud',
      tooltip:
        'De mogelijkheid om je huidige telefoonnummer mee te nemen naar de nieuwe aanbieder.',
      value: AvailabilityIcon(numberPorting),
    },
    {
      label: 'Starttarief',
      tooltip:
        'De kosten die de aanbieder in rekening brengt voor bellen naar vaste nummers binnen je netgebied.',
      value: getRateDisplay(rateWithinRegion),
    },
    {
      label: 'Bellen buiten de regio',
      tooltip:
        'De kosten die de aanbieder in rekening brengt voor bellen naar vaste nummers binnen Nederland, maar buiten je netgebied.',
      value: getRateDisplay(rateOutsideRegion),
    },
    {
      label: 'Bellen naar mobiel',
      tooltip:
        'De kosten die de aanbieder in rekening brengt voor bellen naar mobiele nummers.',
      value: getRateDisplay(mobile),
    },
    {
      label: 'Nummerweergave',
      tooltip: 'Met nummerweergave kun je zien wie er belt.',
      value: AvailabilityIcon(callerIdVisibility),
    },
    {
      label: 'Voicemail',
      tooltip: 'Bij deze aanbieder kun je een voicemail instellen.',
      value: AvailabilityIcon(voicemail),
    },
  ];
};
